import { Link } from "react-router-dom";

export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_valora-respite/artifacts/u2vy0df6_ChatGPT%20Image%20Jun%2011%2C%202026%2C%2004_01_03%20PM.png";

export const Logo = ({ variant = "default", size = "md" }) => {
  const inverse = variant === "inverse";
  const heights = { sm: "h-9", md: "h-11 lg:h-12", lg: "h-16 lg:h-20" };
  const img = (
    <img
      src={LOGO_URL}
      alt="Valora Support Services"
      className={`${heights[size]} w-auto block select-none`}
      draggable={false}
      loading="eager"
    />
  );
  return (
    <Link to="/" data-testid="logo-link" aria-label="Valora Support Services — home" className="inline-flex items-center">
      {inverse ? (
        <span className="block bg-white rounded-xl px-3 py-2 shadow-[0_8px_20px_-10px_rgba(0,0,0,0.4)]">
          {img}
        </span>
      ) : (
        img
      )}
    </Link>
  );
};

export default Logo;
